import { render, staticRenderFns } from "./DogRegistrationIndividualRegistrationSignatures.vue?vue&type=template&id=65d8cbb0"
import script from "./DogRegistrationIndividualRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports